module.exports = [
	{
		"source": "100percentfedup.com",
		"language": "en",
		"type": "bias",
		"notes": "",
		"fileName": "100percentfedupcom.jpg"
	},
	{
		"source": "21stcenturywire.com",
		"language": "en",
		"type": "conspiracy",
		"notes": "",
		"fileName": "21stcenturywirecom.jpg"
	},
	{
		"source": "24extremeworld.com",
		"language": "en",
		"type": "fake",
		"notes": "",
		"fileName": "24extremeworldcom.jpg"
	},
	{
		"source": "365usanews.com",
		"language": "en",
		"type": "fake",
		"notes": "",
		"fileName": "365usanewscom.jpg"
	},
	{
		"source": "4threvolutionarywar.wordpress.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "4threvolutionarywarwordpresscom.jpg"
	},
	{
		"source": "70news.wordpress.com",
		"language": "en",
		"type": "fake",
		"notes": "",
		"fileName": "70newswordpresscom.jpg"
	},
	{
		"source": "aanirfan.blogspot.co.uk",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "aanirfanblogspotcouk.jpg"
	},
	{
		"source": "abcnews.com.co",
		"language": "en",
		"type": "fake",
		"notes": "",
		"fileName": "abcnewscomco.jpg"
	},
	{
		"source": "abcnewsgo.co",
		"language": "en",
		"type": "fake",
		"notes": "",
		"fileName": "abcnewsgoco.jpg"
	},
	{
		"source": "abeldanger.net",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "abeldangernet.jpg"
	},
	{
		"source": "abovetopsecret.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "abovetopsecretcom.jpg"
	},
	{
		"source": "abriluno.com",
		"language": "en",
		"type": "fake",
		"notes": "",
		"fileName": "abrilunocom.jpg"
	},
	{
		"source": "aceflashman.wordpress.com",
		"language": "en",
		"type": "fake",
		"notes": "",
		"fileName": "aceflashmanwordpresscom.jpg"
	},
	{
		"source": "activistpost.com",
		"language": "en",
		"type": "conspiracy",
		"notes": "",
		"fileName": "activistpostcom.jpg"
	},
	{
		"source": "addictinginfo.org",
		"language": "en",
		"type": "bias",
		"notes": "",
		"fileName": "addictinginfoorg.jpg"
	},
	{
		"source": "adobochronicles.com",
		"language": "en",
		"type": "fake",
		"notes": "",
		"fileName": "adobochroniclescom.jpg"
	},
	{
		"source": "ahtribune.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "ahtribunecom.jpg"
	},
	{
		"source": "allnewspipeline.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "allnewspipelinecom.jpg"
	},
	{
		"source": "allpoliticsnews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "allpoliticsnewscom.jpg"
	},
	{
		"source": "americanlookout.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "americanlookoutcom.jpg"
	},
	{
		"source": "americannews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "americannewscom.jpg"
	},
	{
		"source": "americantoday.news",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "americantodaynews.jpg"
	},
	{
		"source": "americasfreedomfighters.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "americasfreedomfighterscom.jpg"
	},
	{
		"source": "amplifyingglass.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "amplifyingglasscom.jpg"
	},
	{
		"source": "amren.com",
		"language": "en",
		"type": "hate",
		"notes": "",
		"fileName": "amrencom.jpg"
	},
	{
		"source": "amtvmedia.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "amtvmediacom.jpg"
	},
	{
		"source": "amusmentic.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "amusmenticcom.jpg"
	},
	{
		"source": "ancient-code.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "ancientcodecom.jpg"
	},
	{
		"source": "anonews.co",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "anonewsco.jpg"
	},
	{
		"source": "anonhq.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "anonhqcom.jpg"
	},
	{
		"source": "anonnews.co",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "anonnewsco.jpg"
	},
	{
		"source": "asia-pacificresearch.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "asiapacificresearchcom.jpg"
	},
	{
		"source": "assassinationscience.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "assassinationsciencecom.jpg"
	},
	{
		"source": "associatedmediacoverage.com",
		"language": "en",
		"type": "satire",
		"notes": "",
		"fileName": "associatedmediacoveragecom.jpg"
	},
	{
		"source": "automotostar.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "automotostarcom.jpg"
	},
	{
		"source": "awdnews.com",
		"language": "en",
		"type": "conspiracy",
		"notes": "",
		"fileName": "awdnewscom.jpg"
	},
	{
		"source": "awesomethings4you.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "awesomethings4youcom.jpg"
	},
	{
		"source": "baltimoregazette.com",
		"language": "en",
		"type": "fake",
		"notes": "",
		"fileName": "baltimoregazettecom.jpg"
	},
	{
		"source": "banoosh.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "banooshcom.jpg"
	},
	{
		"source": "barenakedislam.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "barenakedislamcom.jpg"
	},
	{
		"source": "beehivebugle.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "beehivebuglecom.jpg"
	},
	{
		"source": "beforeitsnews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "beforeitsnewscom.jpg"
	},
	{
		"source": "berniesandersnews.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "berniesandersnewsorg.jpg"
	},
	{
		"source": "betootaadvocate.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "betootaadvocatecom.jpg"
	},
	{
		"source": "bients.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "bientscom.jpg"
	},
	{
		"source": "bigamericannews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "bigamericannewscom.jpg"
	},
	{
		"source": "bigbluedimension.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "bigbluedimensioncom.jpg"
	},
	{
		"source": "bigbluevision.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "bigbluevisioncom.jpg"
	},
	{
		"source": "bigbluevision.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "bigbluevisionorg.jpg"
	},
	{
		"source": "bignuggetnews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "bignuggetnewscom.jpg"
	},
	{
		"source": "bigpzone.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "bigpzonecom.jpg"
	},
	{
		"source": "bipartisanreport.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "bipartisanreportcom.jpg"
	},
	{
		"source": "blacklistednews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "blacklistednewscom.jpg"
	},
	{
		"source": "bluenationreview.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "bluenationreviewcom.jpg"
	},
	{
		"source": "borowitzreport.com",
		"language": "en",
		"type": "satire",
		"notes": "",
		"fileName": "borowitzreportcom.jpg"
	},
	{
		"source": "bostonleader.com",
		"language": "en",
		"type": "fake",
		"notes": "",
		"fileName": "bostonleadercom.jpg"
	},
	{
		"source": "breitbart.com",
		"language": "en",
		"type": "bias",
		"notes": "",
		"fileName": "breitbartcom.jpg"
	},
	{
		"source": "buzzfeedusa.com",
		"language": "en",
		"type": "fake",
		"notes": "",
		"fileName": "buzzfeedusacom.jpg"
	},
	{
		"source": "bvanews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "bvanewscom.jpg"
	},
	{
		"source": "callthecops.net",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "callthecopsnet.jpg"
	},
	{
		"source": "cap-news.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "capnewscom.jpg"
	},
	{
		"source": "celebtricity.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "celebtricitycom.jpg"
	},
	{
		"source": "centralnewsamerica.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "centralnewsamericacom.jpg"
	},
	{
		"source": "chaser.com.au",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "chasercomau.jpg"
	},
	{
		"source": "checkoutthehealthyworld.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "checkoutthehealthyworldcom.jpg"
	},
	{
		"source": "christianfightback.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "christianfightbackcom.jpg"
	},
	{
		"source": "christiantimesnewspaper.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "christiantimesnewspapercom.jpg"
	},
	{
		"source": "christwire.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "christwireorg.jpg"
	},
	{
		"source": "chronicle.su",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "chroniclesu.jpg"
	},
	{
		"source": "cityworldnews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "cityworldnewscom.jpg"
	},
	{
		"source": "civictribune.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "civictribunecom.jpg"
	},
	{
		"source": "clickhole.com",
		"language": "en",
		"type": "satire",
		"notes": "",
		"fileName": "clickholecom.jpg"
	},
	{
		"source": "cnnnext.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "cnnnextcom.jpg"
	},
	{
		"source": "coasttocoastam.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "coasttocoastamcom.jpg"
	},
	{
		"source": "collective-evolution.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "collectiveevolutioncom.jpg"
	},
	{
		"source": "concisepolitics.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "concisepoliticscom.jpg"
	},
	{
		"source": "consciouslifenews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "consciouslifenewscom.jpg"
	},
	{
		"source": "conservativedailypost.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "conservativedailypostcom.jpg"
	},
	{
		"source": "conservativeoutfitters.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "conservativeoutfitterscom.jpg"
	},
	{
		"source": "conspiracywire.com",
		"language": "en",
		"type": "conspiracy",
		"notes": "",
		"fileName": "conspiracywirecom.jpg"
	},
	{
		"source": "corbettreport.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "corbettreportcom.jpg"
	},
	{
		"source": "cosmicscientist.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "cosmicscientistcom.jpg"
	},
	{
		"source": "cosmo-politics.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "cosmopoliticscom.jpg"
	},
	{
		"source": "countdowntozerotime.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "countdowntozerotimecom.jpg"
	},
	{
		"source": "countercurrents.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "countercurrentsorg.jpg"
	},
	{
		"source": "counterinformation.wordpress.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "counterinformationwordpresscom.jpg"
	},
	{
		"source": "counterpsyops.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "counterpsyopscom.jpg"
	},
	{
		"source": "counterpunch.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "counterpunchcom.jpg"
	},
	{
		"source": "counterpunch.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "counterpunchorg.jpg"
	},
	{
		"source": "creambmp.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "creambmpcom.jpg"
	},
	{
		"source": "crystalair.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "crystalaircom.jpg"
	},
	{
		"source": "dailybuzzlive.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "dailybuzzlivecom.jpg"
	},
	{
		"source": "dailycurrant.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "dailycurrantcom.jpg"
	},
	{
		"source": "dailydemocraticnews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "dailydemocraticnewscom.jpg"
	},
	{
		"source": "dailyleak.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "dailyleakorg.jpg"
	},
	{
		"source": "dailynews24-7.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "dailynews247com.jpg"
	},
	{
		"source": "dailynewsbin.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "dailynewsbincom.jpg"
	},
	{
		"source": "dailyoccupation.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "dailyoccupationcom.jpg"
	},
	{
		"source": "dailypoliticsusa.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "dailypoliticsusacom.jpg"
	},
	{
		"source": "dailysquib.co.uk",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "dailysquibcouk.jpg"
	},
	{
		"source": "dailystormer.com",
		"language": "en",
		"type": "hate",
		"notes": "",
		"fileName": "dailystormercom.jpg"
	},
	{
		"source": "dailywire.com",
		"language": "en",
		"type": "bias",
		"notes": "",
		"fileName": "dailywirecom.jpg"
	},
	{
		"source": "darkmoon.me",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "darkmoonme.jpg"
	},
	{
		"source": "darkpolitricks.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "darkpolitrickscom.jpg"
	},
	{
		"source": "davidduke.com",
		"language": "en",
		"type": "hate",
		"notes": "",
		"fileName": "daviddukecom.jpg"
	},
	{
		"source": "davidstockmanscontracorner.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "davidstockmanscontracornercom.jpg"
	},
	{
		"source": "davidwolfe.com",
		"language": "en",
		"type": "junksci",
		"notes": "",
		"fileName": "davidwolfecom.jpg"
	},
	{
		"source": "dcclothesline.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "dcclotheslinecom.jpg"
	},
	{
		"source": "dcgazette.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "dcgazettecom.jpg"
	},
	{
		"source": "dcleaks.com",
		"language": "en",
		"type": "caution",
		"notes": "",
		"fileName": "dcleakscom.jpg"
	},
	{
		"source": "defenddemocracy.press",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "defenddemocracypress.jpg"
	},
	{
		"source": "delectabledietofpics.net",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "delectabledietofpicsnet.jpg"
	},
	{
		"source": "dennismichaellynch.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "dennismichaellynchcom.jpg"
	},
	{
		"source": "denverguardian.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "denverguardiancom.jpg"
	},
	{
		"source": "departed.co",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "departedco.jpg"
	},
	{
		"source": "derfmagazine.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "derfmagazinecom.jpg"
	},
	{
		"source": "dineal.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "dinealcom.jpg"
	},
	{
		"source": "disclose.tv",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "disclosetv.jpg"
	},
	{
		"source": "disclosuremedia.net",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "disclosuremedianet.jpg"
	},
	{
		"source": "diversitychronicle.wordpress.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "diversitychroniclewordpresscom.jpg"
	},
	{
		"source": "doctorhealth365.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "doctorhealth365com.jpg"
	},
	{
		"source": "drudgereport.com.co",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "drudgereportcomco.jpg"
	},
	{
		"source": "drudgereport.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "drudgereportcom.jpg"
	},
	{
		"source": "duffleblog.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "duffleblogcom.jpg"
	},
	{
		"source": "duhprogressive.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "duhprogressivecom.jpg"
	},
	{
		"source": "eatinghealthytricks.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "eatinghealthytrickscom.jpg"
	},
	{
		"source": "educate-yourself.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "educateyourselforg.jpg"
	},
	{
		"source": "educateinspirechange.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "educateinspirechangeorg.jpg"
	},
	{
		"source": "elelephantintheroom.blogspot.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "elelephantintheroomblogspotcom.jpg"
	},
	{
		"source": "elitereaders.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "elitereaderscom.jpg"
	},
	{
		"source": "elkoshary.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "elkosharycom.jpg"
	},
	{
		"source": "elmundotoday.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "elmundotodaycom.jpg"
	},
	{
		"source": "embols.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "embolscom.jpg"
	},
	{
		"source": "empireherald.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "empireheraldcom.jpg"
	},
	{
		"source": "empirenews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "empirenewscom.jpg"
	},
	{
		"source": "empirenews.net",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "empirenewsnet.jpg"
	},
	{
		"source": "empiresports.co",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "empiresportsco.jpg"
	},
	{
		"source": "enabon.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "enaboncom.jpg"
	},
	{
		"source": "endingthefed.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "endingthefedcom.jpg"
	},
	{
		"source": "endoftheamericandream.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "endoftheamericandreamcom.jpg"
	},
	{
		"source": "endtime.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "endtimecom.jpg"
	},
	{
		"source": "enduringvision.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "enduringvisioncom.jpg"
	},
	{
		"source": "english.ruvr.ru",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "englishruvrru.jpg"
	},
	{
		"source": "eutimes.net",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "eutimesnet.jpg"
	},
	{
		"source": "eutopia.buzz",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "eutopiabuzz.jpg"
	},
	{
		"source": "ewao.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "ewaocom.jpg"
	},
	{
		"source": "extraclubmagazine.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "extraclubmagazinecom.jpg"
	},
	{
		"source": "eyeopening.info",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "eyeopeninginfo.jpg"
	},
	{
		"source": "fakingnews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "fakingnewscom.jpg"
	},
	{
		"source": "fantasticword.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "fantasticwordcom.jpg"
	},
	{
		"source": "federalistpress.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "federalistpresscom.jpg"
	},
	{
		"source": "fellowshipoftheminds.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "fellowshipofthemindscom.jpg"
	},
	{
		"source": "filmsforaction.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "filmsforactionorg.jpg"
	},
	{
		"source": "floridasunpost.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "floridasunpostcom.jpg"
	},
	{
		"source": "flyheight.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "flyheightcom.jpg"
	},
	{
		"source": "fognews.ru",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "fognewsru.jpg"
	},
	{
		"source": "foodbabe.com",
		"language": "en",
		"type": "junksci",
		"notes": "",
		"fileName": "foodbabecom.jpg"
	},
	{
		"source": "foreignpolicyjournal.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "foreignpolicyjournalcom.jpg"
	},
	{
		"source": "fort-russ.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "fortrusscom.jpg"
	},
	{
		"source": "fourwinds10.net",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "fourwinds10net.jpg"
	},
	{
		"source": "fprnradio.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "fprnradiocom.jpg"
	},
	{
		"source": "freedomoutpost.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "freedomoutpostcom.jpg"
	},
	{
		"source": "freepatriot.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "freepatriotorg.jpg"
	},
	{
		"source": "freewoodpost.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "freewoodpostcom.jpg"
	},
	{
		"source": "fromthetrenchesworldreport.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "fromthetrenchesworldreportcom.jpg"
	},
	{
		"source": "frontpagemag.com",
		"language": "en",
		"type": "hate",
		"notes": "",
		"fileName": "frontpagemagcom.jpg"
	},
	{
		"source": "galacticconnection.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "galacticconnectioncom.jpg"
	},
	{
		"source": "gangstergovernment.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "gangstergovernmentcom.jpg"
	},
	{
		"source": "gatesofvienna.net",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "gatesofviennanet.jpg"
	},
	{
		"source": "geoengineeringwatch.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "geoengineeringwatchorg.jpg"
	},
	{
		"source": "geopolmonitor.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "geopolmonitorcom.jpg"
	},
	{
		"source": "globalresearch.ca",
		"language": "en",
		"type": "conspiracy",
		"notes": "",
		"fileName": "globalresearchca.jpg"
	},
	{
		"source": "godlikeproductions.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "godlikeproductionscom.jpg"
	},
	{
		"source": "gomerblog.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "gomerblogcom.jpg"
	},
	{
		"source": "govtslaves.info",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "govtslavesinfo.jpg"
	},
	{
		"source": "greanvillepost.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "greanvillepostcom.jpg"
	},
	{
		"source": "guardianlv.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "guardianlvcom.jpg"
	},
	{
		"source": "guccifer2.wordpress.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "guccifer2wordpresscom.jpg"
	},
	{
		"source": "gulagbound.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "gulagboundcom.jpg"
	},
	{
		"source": "hangthebankers.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "hangthebankerscom.jpg"
	},
	{
		"source": "healthimpactnews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "healthimpactnewscom.jpg"
	},
	{
		"source": "healthnutnews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "healthnutnewscom.jpg"
	},
	{
		"source": "henrymakow.com",
		"language": "en",
		"type": "hate",
		"notes": "",
		"fileName": "henrymakowcom.jpg"
	},
	{
		"source": "heresyblog.net",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "heresyblognet.jpg"
	},
	{
		"source": "holyobserver.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "holyobservercom.jpg"
	},
	{
		"source": "humansarefree.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "humansarefreecom.jpg"
	},
	{
		"source": "huzlers.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "huzlerscom.jpg"
	},
	{
		"source": "ifyouonlynews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "ifyouonlynewscom.jpg"
	},
	{
		"source": "igrewupinusa.info",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "igrewupinusainfo.jpg"
	},
	{
		"source": "ihavethetruth.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "ihavethetruthcom.jpg"
	},
	{
		"source": "ijr.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "ijrcom.jpg"
	},
	{
		"source": "in5d.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "in5dcom.jpg"
	},
	{
		"source": "indiaarising.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "indiaarisingcom.jpg"
	},
	{
		"source": "informationclearinghouse.info",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "informationclearinghouseinfo.jpg"
	},
	{
		"source": "informetoday.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "informetodaycom.jpg"
	},
	{
		"source": "infowars.com",
		"language": "en",
		"type": "conspiracy",
		"notes": "",
		"fileName": "infowarscom.jpg"
	},
	{
		"source": "inquisitor.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "inquisitorcom.jpg"
	},
	{
		"source": "instaworldnews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "instaworldnewscom.jpg"
	},
	{
		"source": "intellihub.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "intellihubcom.jpg"
	},
	{
		"source": "intrendtoday.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "intrendtodaycom.jpg"
	},
	{
		"source": "intrepidreport.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "intrepidreportcom.jpg"
	},
	{
		"source": "investmentresearchdynamics.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "investmentresearchdynamicscom.jpg"
	},
	{
		"source": "investmentwatchblog.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "investmentwatchblogcom.jpg"
	},
	{
		"source": "itaglive.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "itaglivecom.jpg"
	},
	{
		"source": "iwanttoexplore.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "iwanttoexplorecom.jpg"
	},
	{
		"source": "jackpineradicals.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "jackpineradicalscom.jpg"
	},
	{
		"source": "jamesrgrangerjr.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "jamesrgrangerjrcom.jpg"
	},
	{
		"source": "jesus-is-savior.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "jesusissaviorcom.jpg"
	},
	{
		"source": "jewsnews.co.il",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "jewsnewscoil.jpg"
	},
	{
		"source": "jonesreport.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "jonesreportcom.jpg"
	},
	{
		"source": "journal-neo.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "journalneoorg.jpg"
	},
	{
		"source": "katehon.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "katehoncom.jpg"
	},
	{
		"source": "katehon.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "katehonorg.jpg"
	},
	{
		"source": "kingworldnews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "kingworldnewscom.jpg"
	},
	{
		"source": "landoverbaptist.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "landoverbaptistorg.jpg"
	},
	{
		"source": "latestnews5.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "latestnews5com.jpg"
	},
	{
		"source": "lewrockwell.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "lewrockwellcom.jpg"
	},
	{
		"source": "liberalbias.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "liberalbiascom.jpg"
	},
	{
		"source": "libertyblitzkrieg.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "libertyblitzkriegcom.jpg"
	},
	{
		"source": "libertymovementradio.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "libertymovementradiocom.jpg"
	},
	{
		"source": "libertynews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "libertynewscom.jpg"
	},
	{
		"source": "libertytalk.fm",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "libertytalkfm.jpg"
	},
	{
		"source": "libertyunyielding.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "libertyunyieldingcom.jpg"
	},
	{
		"source": "libertyvideos.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "libertyvideosorg.jpg"
	},
	{
		"source": "libertywritersnews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "libertywritersnewscom.jpg"
	},
	{
		"source": "lifeandabout.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "lifeandaboutcom.jpg"
	},
	{
		"source": "lifeprevention.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "lifepreventioncom.jpg"
	},
	{
		"source": "lightlybraisedturnip.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "lightlybraisedturnipcom.jpg"
	},
	{
		"source": "livefreelivenatural.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "livefreelivenaturalcom.jpg"
	},
	{
		"source": "livevote.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "livevotecom.jpg"
	},
	{
		"source": "lushforlife.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "lushforlifecom.jpg"
	},
	{
		"source": "madworldnews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "madworldnewscom.jpg"
	},
	{
		"source": "magafeed.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "magafeedcom.jpg"
	},
	{
		"source": "makeamericagreattoday.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "makeamericagreattodaycom.jpg"
	},
	{
		"source": "mediazone.news",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "mediazonenews.jpg"
	},
	{
		"source": "megafreshnews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "megafreshnewscom.jpg"
	},
	{
		"source": "megynkelly.us",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "megynkellyus.jpg"
	},
	{
		"source": "memoryholeblog.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "memoryholeblogcom.jpg"
	},
	{
		"source": "miniplanet.us",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "miniplanetus.jpg"
	},
	{
		"source": "mintpressnews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "mintpressnewscom.jpg"
	},
	{
		"source": "moonofalabama.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "moonofalabamaorg.jpg"
	},
	{
		"source": "morningnewsusa.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "morningnewsusacom.jpg"
	},
	{
		"source": "mrconservative.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "mrconservativecom.jpg"
	},
	{
		"source": "msnbc.website",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "msnbcwebsite.jpg"
	},
	{
		"source": "nahadaily.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "nahadailycom.jpg"
	},
	{
		"source": "nationalreport.net",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "nationalreportnet.jpg"
	},
	{
		"source": "naturalblaze.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "naturalblazecom.jpg"
	},
	{
		"source": "naturalcuresnotmedicine.com",
		"language": "en",
		"type": "junksci",
		"notes": "",
		"fileName": "naturalcuresnotmedicinecom.jpg"
	},
	{
		"source": "naturalnews.com",
		"language": "en",
		"type": "junksci",
		"notes": "",
		"fileName": "naturalnewscom.jpg"
	},
	{
		"source": "nbcpolitics.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "nbcpoliticsorg.jpg"
	},
	{
		"source": "nbcpoll.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "nbcpollcom.jpg"
	},
	{
		"source": "ncscooper.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "ncscoopercom.jpg"
	},
	{
		"source": "newcenturytimes.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "newcenturytimescom.jpg"
	},
	{
		"source": "newcoldwar.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "newcoldwarorg.jpg"
	},
	{
		"source": "news-hound.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "newshoundcom.jpg"
	},
	{
		"source": "news-hound.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "newshoundorg.jpg"
	},
	{
		"source": "newsbbc.net",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "newsbbcnet.jpg"
	},
	{
		"source": "newsbiscuit.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "newsbiscuitcom.jpg"
	},
	{
		"source": "newsbuzzdaily.com",
		"language": "en",
		"type": "fake",
		"notes": "",
		"fileName": "newsbuzzdailycom.jpg"
	},
	{
		"source": "newscenterusa.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "newscenterusacom.jpg"
	},
	{
		"source": "newsexaminer.net",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "newsexaminernet.jpg"
	},
	{
		"source": "newsfrompolitics.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "newsfrompoliticscom.jpg"
	},
	{
		"source": "newslo.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "newslocom.jpg"
	},
	{
		"source": "newsmutiny.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "newsmutinycom.jpg"
	},
	{
		"source": "newstarget.com",
		"language": "en",
		"type": "conspiracy",
		"notes": "",
		"fileName": "newstargetcom.jpg"
	},
	{
		"source": "newsthump.com",
		"language": "en",
		"type": "satire",
		"notes": "",
		"fileName": "newsthumpcom.jpg"
	},
	{
		"source": "newstoad.net",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "newstoadnet.jpg"
	},
	{
		"source": "newswatch28.com",
		"language": "en",
		"type": "fake",
		"notes": "",
		"fileName": "newswatch28com.jpg"
	},
	{
		"source": "newswatch33.com",
		"language": "en",
		"type": "fake",
		"notes": "",
		"fileName": "newswatch33com.jpg"
	},
	{
		"source": "newswire-24.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "newswire24com.jpg"
	},
	{
		"source": "newswithviews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "newswithviewscom.jpg"
	},
	{
		"source": "nodisinfo.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "nodisinfocom.jpg"
	},
	{
		"source": "notallowedto.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "notallowedtocom.jpg"
	},
	{
		"source": "now8news.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "now8newscom.jpg"
	},
	{
		"source": "nowtheendbegins.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "nowtheendbeginscom.jpg"
	},
	{
		"source": "nutritionfacts.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "nutritionfactsorg.jpg"
	},
	{
		"source": "nymeta.co",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "nymetaco.jpg"
	},
	{
		"source": "nyuzer.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "nyuzercom.jpg"
	},
	{
		"source": "objectiveministries.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "objectiveministriesorg.jpg"
	},
	{
		"source": "occupydemocrats.com",
		"language": "en",
		"type": "bias",
		"notes": "",
		"fileName": "occupydemocratscom.jpg"
	},
	{
		"source": "occupyliberals.com",
		"language": "en",
		"type": "bias",
		"notes": "",
		"fileName": "occupyliberalscom.jpg"
	},
	{
		"source": "odgossip.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "odgossipcom.jpg"
	},
	{
		"source": "off-guardian.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "offguardianorg.jpg"
	},
	{
		"source": "oftwominds.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "oftwomindscom.jpg"
	},
	{
		"source": "oilgeopolitics.net",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "oilgeopoliticsnet.jpg"
	},
	{
		"source": "opednews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "opednewscom.jpg"
	},
	{
		"source": "openmindmagazine.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "openmindmagazinecom.jpg"
	},
	{
		"source": "orientalreview.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "orientalrevieworg.jpg"
	},
	{
		"source": "other98.com",
		"language": "en",
		"type": "clickbait",
		"notes": "",
		"fileName": "other98com.jpg"
	},
	{
		"source": "patriotchronicle.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "patriotchroniclecom.jpg"
	},
	{
		"source": "patriotrising.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "patriotrisingcom.jpg"
	},
	{
		"source": "paulcraigroberts.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "paulcraigrobertsorg.jpg"
	},
	{
		"source": "platosguns.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "platosgunscom.jpg"
	},
	{
		"source": "politicalblindspot.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "politicalblindspotcom.jpg"
	},
	{
		"source": "politicalears.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "politicalearscom.jpg"
	},
	{
		"source": "politicalo.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "politicalocom.jpg"
	},
	{
		"source": "politicalsitenews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "politicalsitenewscom.jpg"
	},
	{
		"source": "politicaltimes.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "politicaltimesorg.jpg"
	},
	{
		"source": "politicsinformation.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "politicsinformationcom.jpg"
	},
	{
		"source": "politicsintheusa.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "politicsintheusacom.jpg"
	},
	{
		"source": "politicususa.com",
		"language": "en",
		"type": "bias",
		"notes": "",
		"fileName": "politicususacom.jpg"
	},
	{
		"source": "powerpoliticians.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "powerpoliticianscom.jpg"
	},
	{
		"source": "pravda.ru",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "pravdaru.jpg"
	},
	{
		"source": "pravdareport.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "pravdareportcom.jpg"
	},
	{
		"source": "prepperwebsite.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "prepperwebsitecom.jpg"
	},
	{
		"source": "presidentialvoting2016.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "presidentialvoting2016com.jpg"
	},
	{
		"source": "press24.us",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "press24us.jpg"
	},
	{
		"source": "presstv.com",
		"language": "en",
		"type": "state",
		"notes": "",
		"fileName": "presstvcom.jpg"
	},
	{
		"source": "presstv.ir",
		"language": "en",
		"type": "state",
		"notes": "",
		"fileName": "presstvir.jpg"
	},
	{
		"source": "prisonplanet.com",
		"language": "en",
		"type": "conspiracy",
		"notes": "",
		"fileName": "prisonplanetcom.jpg"
	},
	{
		"source": "prisonplanet.tv",
		"language": "en",
		"type": "conspiracy",
		"notes": "",
		"fileName": "prisonplanettv.jpg"
	},
	{
		"source": "projectveritas.com",
		"language": "en",
		"type": "bias",
		"notes": "",
		"fileName": "projectveritascom.jpg"
	},
	{
		"source": "proudemocrat.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "proudemocratcom.jpg"
	},
	{
		"source": "randpaulreview.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "randpaulreviewcom.jpg"
	},
	{
		"source": "rawforbeauty.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "rawforbeautycom.jpg"
	},
	{
		"source": "rawws.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "rawwscom.jpg"
	},
	{
		"source": "rbth.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "rbthcom.jpg"
	},
	{
		"source": "react365.com",
		"language": "en",
		"type": "fake",
		"notes": "",
		"fileName": "react365com.jpg"
	},
	{
		"source": "readynutrition.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "readynutritioncom.jpg"
	},
	{
		"source": "realfarmacy.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "realfarmacycom.jpg"
	},
	{
		"source": "realnewsrightnow.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "realnewsrightnowcom.jpg"
	},
	{
		"source": "realplanetnews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "realplanetnewscom.jpg"
	},
	{
		"source": "redflagnews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "redflagnewscom.jpg"
	},
	{
		"source": "redstatewatcher.com",
		"language": "en",
		"type": "bias",
		"notes": "",
		"fileName": "redstatewatchercom.jpg"
	},
	{
		"source": "reductress.com",
		"language": "en",
		"type": "satire",
		"notes": "",
		"fileName": "reductresscom.jpg"
	},
	{
		"source": "regated.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "regatedcom.jpg"
	},
	{
		"source": "rense.com",
		"language": "en",
		"type": "conspiracy",
		"notes": "",
		"fileName": "rensecom.jpg"
	},
	{
		"source": "responsibletechnology.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "responsibletechnologyorg.jpg"
	},
	{
		"source": "returnofkings.com",
		"language": "en",
		"type": "hate",
		"notes": "",
		"fileName": "returnofkingscom.jpg"
	},
	{
		"source": "righton.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "rightoncom.jpg"
	},
	{
		"source": "rilenews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "rilenewscom.jpg"
	},
	{
		"source": "rinf.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "rinfcom.jpg"
	},
	{
		"source": "rockcitytimes.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "rockcitytimescom.jpg"
	},
	{
		"source": "ronpaulinstitute.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "ronpaulinstituteorg.jpg"
	},
	{
		"source": "rumormillnews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "rumormillnewscom.jpg"
	},
	{
		"source": "ruptly.tv",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "ruptlytv.jpg"
	},
	{
		"source": "russia-direct.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "russiadirectorg.jpg"
	},
	{
		"source": "russia-insider.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "russiainsidercom.jpg"
	},
	{
		"source": "satiratribune.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "satiratribunecom.jpg"
	},
	{
		"source": "satirewire.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "satirewirecom.jpg"
	},
	{
		"source": "scrappleface.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "scrapplefacecom.jpg"
	},
	{
		"source": "secretsofthefed.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "secretsofthefedcom.jpg"
	},
	{
		"source": "sentinelblog.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "sentinelblogcom.jpg"
	},
	{
		"source": "sgtreport.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "sgtreportcom.jpg"
	},
	{
		"source": "shiftfrequency.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "shiftfrequencycom.jpg"
	},
	{
		"source": "shtfplan.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "shtfplancom.jpg"
	},
	{
		"source": "silentmajoritypatriots.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "silentmajoritypatriotscom.jpg"
	},
	{
		"source": "silverdoctors.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "silverdoctorscom.jpg"
	},
	{
		"source": "sott.net",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "sottnet.jpg"
	},
	{
		"source": "sourceplanet.net",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "sourceplanetnet.jpg"
	},
	{
		"source": "southfront.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "southfrontorg.jpg"
	},
	{
		"source": "southweb.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "southweborg.jpg"
	},
	{
		"source": "speciallifeentertainment.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "speciallifeentertainmentcom.jpg"
	},
	{
		"source": "spin-news.com",
		"language": "en",
		"type": "clickbait",
		"notes": "",
		"fileName": "spinnewscom.jpg"
	},
	{
		"source": "spinzon.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "spinzoncom.jpg"
	},
	{
		"source": "sportspickle.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "sportspicklecom.jpg"
	},
	{
		"source": "sputniknews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "sputniknewscom.jpg"
	},
	{
		"source": "stneotscitizen.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "stneotscitizencom.jpg"
	},
	{
		"source": "stormcloudsgathering.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "stormcloudsgatheringcom.jpg"
	},
	{
		"source": "strategic-culture.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "strategiccultureorg.jpg"
	},
	{
		"source": "stuppid.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "stuppidcom.jpg"
	},
	{
		"source": "suggesthealthytips.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "suggesthealthytipscom.jpg"
	},
	{
		"source": "superstation95.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "superstation95com.jpg"
	},
	{
		"source": "survivopedia.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "survivopediacom.jpg"
	},
	{
		"source": "the-newspapers.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "thenewspaperscom.jpg"
	},
	{
		"source": "theantimedia.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "theantimediaorg.jpg"
	},
	{
		"source": "theautogear.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "theautogearcom.jpg"
	},
	{
		"source": "thebeaverton.com",
		"language": "en",
		"type": "satire",
		"notes": "",
		"fileName": "thebeavertoncom.jpg"
	},
	{
		"source": "thebostontribune.com",
		"language": "en",
		"type": "fake",
		"notes": "",
		"fileName": "thebostontribunecom.jpg"
	},
	{
		"source": "thecarsmagazine.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "thecarsmagazinecom.jpg"
	},
	{
		"source": "thecivilian.co.nz",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "thecivilianconz.jpg"
	},
	{
		"source": "thecommonsenseshow.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "thecommonsenseshowcom.jpg"
	},
	{
		"source": "thecontroversialfiles.net",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "thecontroversialfilesnet.jpg"
	},
	{
		"source": "thedailybell.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "thedailybellcom.jpg"
	},
	{
		"source": "thedailymash.co.uk",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "thedailymashcouk.jpg"
	},
	{
		"source": "thedailysheeple.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "thedailysheeplecom.jpg"
	},
	{
		"source": "thedailywtf.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "thedailywtfcom.jpg"
	},
	{
		"source": "theduran.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "thedurancom.jpg"
	},
	{
		"source": "theearthchild.co.za",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "theearthchildcoza.jpg"
	},
	{
		"source": "theeconomiccollapseblog.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "theeconomiccollapseblogcom.jpg"
	},
	{
		"source": "theeventchronicle.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "theeventchroniclecom.jpg"
	},
	{
		"source": "thefederalistpapers.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "thefederalistpapersorg.jpg"
	},
	{
		"source": "thefreethoughtproject.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "thefreethoughtprojectcom.jpg"
	},
	{
		"source": "thegoldwater.com",
		"language": "en",
		"type": "conspiracy",
		"notes": "",
		"fileName": "thegoldwatercom.jpg"
	},
	{
		"source": "thelapine.ca",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "thelapineca.jpg"
	},
	{
		"source": "thelastgreatstand.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "thelastgreatstandcom.jpg"
	},
	{
		"source": "thelastlineofdefense.org",
		"language": "en",
		"type": "fake",
		"notes": "",
		"fileName": "thelastlineofdefenseorg.jpg"
	},
	{
		"source": "themideastbeast.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "themideastbeastcom.jpg"
	},
	{
		"source": "themindunleashed.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "themindunleashedcom.jpg"
	},
	{
		"source": "themindunleashed.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "themindunleashedorg.jpg"
	},
	{
		"source": "thenewamerican.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "thenewamericancom.jpg"
	},
	{
		"source": "thenewsdoctors.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "thenewsdoctorscom.jpg"
	},
	{
		"source": "theonion.com",
		"language": "en",
		"type": "satire",
		"notes": "",
		"fileName": "theonioncom.jpg"
	},
	{
		"source": "theoxymoron.co.uk",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "theoxymoroncouk.jpg"
	},
	{
		"source": "thepoke.co.uk",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "thepokecouk.jpg"
	},
	{
		"source": "theracketreport.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "theracketreportcom.jpg"
	},
	{
		"source": "therebel.media",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "therebelmedia.jpg"
	},
	{
		"source": "thereporterz.com",
		"language": "en",
		"type": "fake",
		"notes": "",
		"fileName": "thereporterzcom.jpg"
	},
	{
		"source": "therightstuff.biz",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "therightstuffbiz.jpg"
	},
	{
		"source": "therundownlive.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "therundownlivecom.jpg"
	},
	{
		"source": "therussophile.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "therussophileorg.jpg"
	},
	{
		"source": "thesaker.is",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "thesakeris.jpg"
	},
	{
		"source": "thesleuthjournal.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "thesleuthjournalcom.jpg"
	},
	{
		"source": "thespoof.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "thespoofcom.jpg"
	},
	{
		"source": "thestatelyharold.com",
		"language": "en",
		"type": "satire",
		"notes": "",
		"fileName": "thestatelyharoldcom.jpg"
	},
	{
		"source": "thetruenews.info",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "thetruenewsinfo.jpg"
	},
	{
		"source": "thetruthseeker.co.uk",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "thetruthseekercouk.jpg"
	},
	{
		"source": "theunrealtimes.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "theunrealtimescom.jpg"
	},
	{
		"source": "theuspatriot.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "theuspatriotcom.jpg"
	},
	{
		"source": "thevalleyreport.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "thevalleyreportcom.jpg"
	},
	{
		"source": "thirdworldtraveler.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "thirdworldtravelercom.jpg"
	},
	{
		"source": "topekasnews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "topekasnewscom.jpg"
	},
	{
		"source": "topinfopost.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "topinfopostcom.jpg"
	},
	{
		"source": "topnewspolitics.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "topnewspoliticscom.jpg"
	},
	{
		"source": "topratedviral.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "topratedviralcom.jpg"
	},
	{
		"source": "toprightnews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "toprightnewscom.jpg"
	},
	{
		"source": "totalworldnews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "totalworldnewscom.jpg"
	},
	{
		"source": "trendingnewsguide.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "trendingnewsguidecom.jpg"
	},
	{
		"source": "trendingnewstoday.net",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "trendingnewstodaynet.jpg"
	},
	{
		"source": "tribuneherald.net",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "tribuneheraldnet.jpg"
	},
	{
		"source": "trueactivist.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "trueactivistcom.jpg"
	},
	{
		"source": "trunews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "trunewscom.jpg"
	},
	{
		"source": "truthandaction.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "truthandactionorg.jpg"
	},
	{
		"source": "truthbroadcastnetwork.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "truthbroadcastnetworkcom.jpg"
	},
	{
		"source": "truthfeed.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "truthfeedcom.jpg"
	},
	{
		"source": "truthfrequencyradio.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "truthfrequencyradiocom.jpg"
	},
	{
		"source": "truthkings.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "truthkingscom.jpg"
	},
	{
		"source": "tunerspeed.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "tunerspeedcom.jpg"
	},
	{
		"source": "turnerradionetwork.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "turnerradionetworkcom.jpg"
	},
	{
		"source": "twitchy.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "twitchycom.jpg"
	},
	{
		"source": "tyronetribulations.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "tyronetribulationscom.jpg"
	},
	{
		"source": "ufoholic.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "ufoholiccom.jpg"
	},
	{
		"source": "unconfirmedsources.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "unconfirmedsourcescom.jpg"
	},
	{
		"source": "undergroundhealth.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "undergroundhealthcom.jpg"
	},
	{
		"source": "undergroundworldnews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "undergroundworldnewscom.jpg"
	},
	{
		"source": "universepolitics.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "universepoliticscom.jpg"
	},
	{
		"source": "unz.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "unzcom.jpg"
	},
	{
		"source": "usadailypolitics.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "usadailypoliticscom.jpg"
	},
	{
		"source": "usadailytime.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "usadailytimecom.jpg"
	},
	{
		"source": "usahitman.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "usahitmancom.jpg"
	},
	{
		"source": "usainfobox.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "usainfoboxcom.jpg"
	},
	{
		"source": "usajournalist.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "usajournalistcom.jpg"
	},
	{
		"source": "usamagazinestudio.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "usamagazinestudiocom.jpg"
	},
	{
		"source": "usanews24hrs.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "usanews24hrscom.jpg"
	},
	{
		"source": "usanewsflash.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "usanewsflashcom.jpg"
	},
	{
		"source": "usanewshome.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "usanewshomecom.jpg"
	},
	{
		"source": "usanewsinsider.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "usanewsinsidercom.jpg"
	},
	{
		"source": "usanewspolitics.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "usanewspoliticscom.jpg"
	},
	{
		"source": "usanewsstudio.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "usanewsstudiocom.jpg"
	},
	{
		"source": "usaonlinepolitics.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "usaonlinepoliticscom.jpg"
	},
	{
		"source": "usaonlinetoday.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "usaonlinetodaycom.jpg"
	},
	{
		"source": "usaphase.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "usaphasecom.jpg"
	},
	{
		"source": "usapoliticsdaily.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "usapoliticsdailycom.jpg"
	},
	{
		"source": "usapoliticsnow.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "usapoliticsnowcom.jpg"
	},
	{
		"source": "usapoliticus.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "usapoliticuscom.jpg"
	},
	{
		"source": "usapowernews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "usapowernewscom.jpg"
	},
	{
		"source": "usascan.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "usascancom.jpg"
	},
	{
		"source": "usasupreme.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "usasupremecom.jpg"
	},
	{
		"source": "usatoday.com.co",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "usatodaycomco.jpg"
	},
	{
		"source": "usatwentyfour.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "usatwentyfourcom.jpg"
	},
	{
		"source": "usblastingnews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "usblastingnewscom.jpg"
	},
	{
		"source": "usdcrisis.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "usdcrisiscom.jpg"
	},
	{
		"source": "usfanzone.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "usfanzonecom.jpg"
	},
	{
		"source": "uslifetoday.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "uslifetodaycom.jpg"
	},
	{
		"source": "usmediacenter.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "usmediacentercom.jpg"
	},
	{
		"source": "uspolitics24.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "uspolitics24com.jpg"
	},
	{
		"source": "uspoliticslive.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "uspoliticslivecom.jpg"
	},
	{
		"source": "usslibertyveteransblog.org",
		"language": "en",
		"type": "conspiracy",
		"notes": "",
		"fileName": "usslibertyveteransblogorg.jpg"
	},
	{
		"source": "usuncut.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "usuncutcom.jpg"
	},
	{
		"source": "usviewer.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "usviewercom.jpg"
	},
	{
		"source": "vdare.com",
		"language": "en",
		"type": "hate",
		"notes": "",
		"fileName": "vdarecom.jpg"
	},
	{
		"source": "veteransnewsnow.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "veteransnewsnowcom.jpg"
	},
	{
		"source": "veteranstoday.com",
		"language": "en",
		"type": "hate",
		"notes": "",
		"fileName": "veteranstodaycom.jpg"
	},
	{
		"source": "vigilantcitizen.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "vigilantcitizencom.jpg"
	},
	{
		"source": "viralliberty.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "virallibertycom.jpg"
	},
	{
		"source": "viraltube.nl",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "viraltubenl.jpg"
	},
	{
		"source": "vonpress.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "vonpresscom.jpg"
	},
	{
		"source": "votocrat.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "votocratcom.jpg"
	},
	{
		"source": "wakeupthesheep.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "wakeupthesheepcom.jpg"
	},
	{
		"source": "wakingtimes.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "wakingtimescom.jpg"
	},
	{
		"source": "washingtonsblog.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "washingtonsblogcom.jpg"
	},
	{
		"source": "waterfordwhispersnews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "waterfordwhispersnewscom.jpg"
	},
	{
		"source": "wearechange.org",
		"language": "en",
		"type": "conspiracy",
		"notes": "",
		"fileName": "wearechangeorg.jpg"
	},
	{
		"source": "weeklyworldnews.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "weeklyworldnewscom.jpg"
	},
	{
		"source": "weshapelife.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "weshapelifeorg.jpg"
	},
	{
		"source": "westernjournalism.com",
		"language": "en",
		"type": "bias",
		"notes": "",
		"fileName": "westernjournalismcom.jpg"
	},
	{
		"source": "whatdoesitmean.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "whatdoesitmeancom.jpg"
	},
	{
		"source": "whatreallyhappened.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "whatreallyhappenedcom.jpg"
	},
	{
		"source": "whydontyoutrythis.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "whydontyoutrythiscom.jpg"
	},
	{
		"source": "wideawakeamerica.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "wideawakeamericacom.jpg"
	},
	{
		"source": "wikileaks.com",
		"language": "en",
		"type": "caution",
		"notes": "",
		"fileName": "wikileakscom.jpg"
	},
	{
		"source": "wikileaks.org",
		"language": "en",
		"type": "caution",
		"notes": "",
		"fileName": "wikileaksorg.jpg"
	},
	{
		"source": "wikispooks.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "wikispookscom.jpg"
	},
	{
		"source": "winningdemocrats.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "winningdemocratscom.jpg"
	},
	{
		"source": "witscience.org",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "witscienceorg.jpg"
	},
	{
		"source": "wnd.com",
		"language": "en",
		"type": "bias",
		"notes": "",
		"fileName": "wndcom.jpg"
	},
	{
		"source": "world24monitor.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "world24monitorcom.jpg"
	},
	{
		"source": "worldcallyoutoday.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "worldcallyoutodaycom.jpg"
	},
	{
		"source": "worldnewsdailyreport.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "worldnewsdailyreportcom.jpg"
	},
	{
		"source": "worldnewspolitics.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "worldnewspoliticscom.jpg"
	},
	{
		"source": "worldrumor.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "worldrumorcom.jpg"
	},
	{
		"source": "worldstoriestoday.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "worldstoriestodaycom.jpg"
	},
	{
		"source": "worldtruth.tv",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "worldtruthtv.jpg"
	},
	{
		"source": "worldwidehealthy.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "worldwidehealthycom.jpg"
	},
	{
		"source": "wundergroundmusic.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "wundergroundmusiccom.jpg"
	},
	{
		"source": "www.rt.com",
		"language": "en",
		"type": "state",
		"notes": "",
		"fileName": "wwwrtcom.jpg"
	},
	{
		"source": "yourfunpage.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "yourfunpagecom.jpg"
	},
	{
		"source": "yournewswire.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "yournewswirecom.jpg"
	},
	{
		"source": "zaytung.com",
		"language": "en",
		"type": "",
		"notes": "",
		"fileName": "zaytungcom.jpg"
	},
	{
		"source": "zerohedge.com",
		"language": "en",
		"type": "conspiracy",
		"notes": "",
		"fileName": "zerohedgecom.jpg"
	},
	{
		"source": "wtoe5news.com",
		"language": "en",
		"type": "fake",
		"notes": "",
		"fileName": "wtoe5newscom.jpg"
	},
	{
		"source": "self.agency",
		"language": "en",
		"type": "test",
		"notes": "",
		"fileName": "selfagency.jpg"
	},
	{
		"source": "1eclaireur.wordpress.com",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "1eclaireurwordpresscom.jpg"
	},
	{
		"source": "2012un-nouveau-paradigme.com",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "2012unnouveauparadigmecom.jpg"
	},
	{
		"source": "24heuresactu.com",
		"language": "",
		"type": "fake",
		"notes": "",
		"fileName": "24heuresactucom.jpg"
	},
	{
		"source": "24orenotizie.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "24orenotiziecom.jpg"
	},
	{
		"source": "999spiritus.org",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "999spiritusorg.jpg"
	},
	{
		"source": "actualites.co",
		"language": "",
		"type": "satire",
		"notes": "",
		"fileName": "actualitesco.jpg"
	},
	{
		"source": "all-news.tv",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "allnewstv.jpg"
	},
	{
		"source": "alleanzadellasalute.info",
		"language": "",
		"type": "junksci",
		"notes": "",
		"fileName": "alleanzadellasaluteinfo.jpg"
	},
	{
		"source": "antiilluminati.net",
		"language": "",
		"type": "",
		"notes": "",
		"fileName": "antiilluminatinet.jpg"
	},
	{
		"source": "aurorasito.wordpress.com",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "aurorasitowordpresscom.jpg"
	},
	{
		"source": "autismovaccini.org",
		"language": "",
		"type": "junksci",
		"notes": "",
		"fileName": "autismovacciniorg.jpg"
	},
	{
		"source": "avortement.net",
		"language": "",
		"type": "fake",
		"notes": "",
		"fileName": "avortementnet.jpg"
	},
	{
		"source": "badatel.net",
		"language": "",
		"type": "",
		"notes": "",
		"fileName": "badatelnet.jpg"
	},
	{
		"source": "benitomussolini.altervista.org",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "benitomussolinialtervistaorg.jpg"
	},
	{
		"source": "blastingnews.com",
		"language": "",
		"type": "",
		"notes": "",
		"fileName": "blastingnewscom.jpg"
	},
	{
		"source": "blognews24ore.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "blognews24orecom.jpg"
	},
	{
		"source": "blogopenyoureyes.altervista.org",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "blogopenyoureyesaltervistaorg.jpg"
	},
	{
		"source": "bravepatrie.com",
		"language": "",
		"type": "satire",
		"notes": "",
		"fileName": "bravepatriecom.jpg"
	},
	{
		"source": "breaknotizie.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "breaknotiziecom.jpg"
	},
	{
		"source": "breizh-info.com",
		"language": "",
		"type": "fake",
		"notes": "",
		"fileName": "breizhinfocom.jpg"
	},
	{
		"source": "byoblu.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "byoblucom.jpg"
	},
	{
		"source": "catenaumana.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "catenaumanacom.jpg"
	},
	{
		"source": "chaos-controle.com",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "chaoscontrolecom.jpg"
	},
	{
		"source": "chiaveorgonica.altervista.org",
		"language": "",
		"type": "fake",
		"notes": "",
		"fileName": "chiaveorgonicaaltervistaorg.jpg"
	},
	{
		"source": "comilva.org",
		"language": "",
		"type": "junksci",
		"notes": "",
		"fileName": "comilvaorg.jpg"
	},
	{
		"source": "condividilo.org",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "condividiloorg.jpg"
	},
	{
		"source": "contribuables.org",
		"language": "",
		"type": "fake",
		"notes": "",
		"fileName": "contribuablesorg.jpg"
	},
	{
		"source": "controinformo.altervista.org",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "controinformoaltervistaorg.jpg"
	},
	{
		"source": "controinformo.info",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "controinformoinfo.jpg"
	},
	{
		"source": "controinformoblog.altervista.org",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "controinformoblogaltervistaorg.jpg"
	},
	{
		"source": "corrieredellapera.com",
		"language": "",
		"type": "satire",
		"notes": "",
		"fileName": "corrieredellaperacom.jpg"
	},
	{
		"source": "corrieredelmattino.altervista.org",
		"language": "",
		"type": "fake",
		"notes": "",
		"fileName": "corrieredelmattinoaltervistaorg.jpg"
	},
	{
		"source": "corruptionssida.canalblog.com",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "corruptionssidacanalblogcom.jpg"
	},
	{
		"source": "cosmofruttariano3m.altervista.org",
		"language": "",
		"type": "junksci",
		"notes": "",
		"fileName": "cosmofruttariano3maltervistaorg.jpg"
	},
	{
		"source": "curiosandoonline.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "curiosandoonlinecom.jpg"
	},
	{
		"source": "curiosity2013.altervista.org",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "curiosity2013altervistaorg.jpg"
	},
	{
		"source": "curiosityalive.altervista.org",
		"language": "",
		"type": "junksci",
		"notes": "",
		"fileName": "curiosityalivealtervistaorg.jpg"
	},
	{
		"source": "cvdiariodelpollinho.altervista.org",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "cvdiariodelpollinhoaltervistaorg.jpg"
	},
	{
		"source": "diktacratie.com",
		"language": "",
		"type": "bias, fake",
		"notes": "",
		"fileName": "diktacratiecom.jpg"
	},
	{
		"source": "dionidream.com",
		"language": "",
		"type": "junksci",
		"notes": "",
		"fileName": "dionidreamcom.jpg"
	},
	{
		"source": "direttanews24.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "direttanews24com.jpg"
	},
	{
		"source": "dondevamos.canalblog.com",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "dondevamoscanalblogcom.jpg"
	},
	{
		"source": "dreuz.info",
		"language": "",
		"type": "fake",
		"notes": "",
		"fileName": "dreuzinfo.jpg"
	},
	{
		"source": "ecocreando.weebly.com",
		"language": "",
		"type": "junksci",
		"notes": "",
		"fileName": "ecocreandoweeblycom.jpg"
	},
	{
		"source": "ecotricolore.altervista.org",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "ecotricolorealtervistaorg.jpg"
	},
	{
		"source": "edukactus.wordpress.com",
		"language": "",
		"type": "satire",
		"notes": "",
		"fileName": "edukactuswordpresscom.jpg"
	},
	{
		"source": "espritsciencemetaphysiques.com",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "espritsciencemetaphysiquescom.jpg"
	},
	{
		"source": "essenzialmentedonna.altervista.org",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "essenzialmentedonnaaltervistaorg.jpg"
	},
	{
		"source": "eticamente.net",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "eticamentenet.jpg"
	},
	{
		"source": "euroasie.info",
		"language": "",
		"type": "",
		"notes": "",
		"fileName": "euroasieinfo.jpg"
	},
	{
		"source": "europeannews.altervista.org",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "europeannewsaltervistaorg.jpg"
	},
	{
		"source": "eurosalus.com",
		"language": "",
		"type": "junksci",
		"notes": "",
		"fileName": "eurosaluscom.jpg"
	},
	{
		"source": "evidenzaliena.altervista.org",
		"language": "",
		"type": "junksci",
		"notes": "",
		"fileName": "evidenzalienaaltervistaorg.jpg"
	},
	{
		"source": "expunere.com",
		"language": "",
		"type": "",
		"notes": "",
		"fileName": "expunerecom.jpg"
	},
	{
		"source": "facebook.com/giornale24ore",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "facebookcomgiornale24ore.jpg"
	},
	{
		"source": "facebooknotizia.altervista.org",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "facebooknotiziaaltervistaorg.jpg"
	},
	{
		"source": "fascinazione.info",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "fascinazioneinfo.jpg"
	},
	{
		"source": "fdesouche.com",
		"language": "",
		"type": "hate",
		"notes": "",
		"fileName": "fdesouchecom.jpg"
	},
	{
		"source": "fr.novopress.info",
		"language": "",
		"type": "hate",
		"notes": "",
		"fileName": "frnovopressinfo.jpg"
	},
	{
		"source": "fr.sott.net",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "frsottnet.jpg"
	},
	{
		"source": "frasideilibri.com",
		"language": "",
		"type": "junksci",
		"notes": "",
		"fileName": "frasideilibricom.jpg"
	},
	{
		"source": "funvideosonline.info",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "funvideosonlineinfo.jpg"
	},
	{
		"source": "gandeste.org",
		"language": "",
		"type": "",
		"notes": "",
		"fileName": "gandesteorg.jpg"
	},
	{
		"source": "gazzetta24.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "gazzetta24com.jpg"
	},
	{
		"source": "gazzettadellasera.com",
		"language": "",
		"type": "fake",
		"notes": "",
		"fileName": "gazzettadellaseracom.jpg"
	},
	{
		"source": "gazzettanews24.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "gazzettanews24com.jpg"
	},
	{
		"source": "giornaleilsole.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "giornaleilsolecom.jpg"
	},
	{
		"source": "grandecocomero.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "grandecocomerocom.jpg"
	},
	{
		"source": "guarda.link",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "guardalink.jpg"
	},
	{
		"source": "guarda.one",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "guardaone.jpg"
	},
	{
		"source": "halonoviny.com",
		"language": "",
		"type": "",
		"notes": "",
		"fileName": "halonovinycom.jpg"
	},
	{
		"source": "henrymakow.wordpress.com",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "henrymakowwordpresscom.jpg"
	},
	{
		"source": "ilbellocheavanza.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "ilbellocheavanzacom.jpg"
	},
	{
		"source": "ilfattaccio.org",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "ilfattaccioorg.jpg"
	},
	{
		"source": "ilmessagero.altervista.org.w3lookup.net",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "ilmessageroaltervistaorgw3lookupnet.jpg"
	},
	{
		"source": "ilnotiziario24.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "ilnotiziario24com.jpg"
	},
	{
		"source": "ilradicale.altervista.org",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "ilradicalealtervistaorg.jpg"
	},
	{
		"source": "ilrisvegliodellamente.altervista.org",
		"language": "",
		"type": "junksci",
		"notes": "",
		"fileName": "ilrisvegliodellamentealtervistaorg.jpg"
	},
	{
		"source": "imigliori.info",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "imiglioriinfo.jpg"
	},
	{
		"source": "imigliorivideo.co",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "imigliorivideoco.jpg"
	},
	{
		"source": "informaction.info",
		"language": "",
		"type": "fake, conspiracy",
		"notes": "",
		"fileName": "informactioninfo.jpg"
	},
	{
		"source": "informazionelibera.eu",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "informazioneliberaeu.jpg"
	},
	{
		"source": "iozummo.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "iozummocom.jpg"
	},
	{
		"source": "irresponsabile.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "irresponsabilecom.jpg"
	},
	{
		"source": "ivg.net",
		"language": "",
		"type": "fake",
		"notes": "",
		"fileName": "ivgnet.jpg"
	},
	{
		"source": "je-to-inak.livejournal.com",
		"language": "",
		"type": "",
		"notes": "",
		"fileName": "jetoinaklivejournalcom.jpg"
	},
	{
		"source": "jedasupport.altervista.org",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "jedasupportaltervistaorg.jpg"
	},
	{
		"source": "jhwhinri.blogspot.com",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "jhwhinriblogspotcom.jpg"
	},
	{
		"source": "kevideo.eu",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "kevideoeu.jpg"
	},
	{
		"source": "la-dissidence.org",
		"language": "",
		"type": "hate",
		"notes": "",
		"fileName": "ladissidenceorg.jpg"
	},
	{
		"source": "labanlieuesexprime.org",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "labanlieuesexprimeorg.jpg"
	},
	{
		"source": "lacontrerevolution.wordpress.com",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "lacontrerevolutionwordpresscom.jpg"
	},
	{
		"source": "lacucinasiciliana.altervista.org",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "lacucinasicilianaaltervistaorg.jpg"
	},
	{
		"source": "laleva.org",
		"language": "",
		"type": "junksci",
		"notes": "",
		"fileName": "lalevaorg.jpg"
	},
	{
		"source": "lanozione.com",
		"language": "",
		"type": "satire",
		"notes": "",
		"fileName": "lanozionecom.jpg"
	},
	{
		"source": "lapillolarossa15.altervista.org",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "lapillolarossa15altervistaorg.jpg"
	},
	{
		"source": "lapressegalactique.net",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "lapressegalactiquenet.jpg"
	},
	{
		"source": "larepubblica.info",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "larepubblicainfo.jpg"
	},
	{
		"source": "last-webs.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "lastwebscom.jpg"
	},
	{
		"source": "lastella.altervista.org",
		"language": "",
		"type": "junksci",
		"notes": "",
		"fileName": "lastellaaltervistaorg.jpg"
	},
	{
		"source": "laveritadininconaco.altervista.org",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "laveritadininconacoaltervistaorg.jpg"
	},
	{
		"source": "Legrandsoir.info",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "Legrandsoirinfo.jpg"
	},
	{
		"source": "lejournaldusiecle.com",
		"language": "",
		"type": "fake",
		"notes": "",
		"fileName": "lejournaldusieclecom.jpg"
	},
	{
		"source": "lelibrepenseur.org",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "lelibrepenseurorg.jpg"
	},
	{
		"source": "lepique.com",
		"language": "",
		"type": "satire",
		"notes": "",
		"fileName": "lepiquecom.jpg"
	},
	{
		"source": "libero-notizie.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "liberonotiziecom.jpg"
	},
	{
		"source": "liberogiornale.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "liberogiornalecom.jpg"
	},
	{
		"source": "likemag.com",
		"language": "",
		"type": "clickbait",
		"notes": "",
		"fileName": "likemagcom.jpg"
	},
	{
		"source": "livewebit.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "livewebitcom.jpg"
	},
	{
		"source": "loguardoconte.info",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "loguardoconteinfo.jpg"
	},
	{
		"source": "lolandesevolante.net",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "lolandesevolantenet.jpg"
	},
	{
		"source": "luogocomune.net",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "luogocomunenet.jpg"
	},
	{
		"source": "mcaris.net",
		"language": "",
		"type": "",
		"notes": "",
		"fileName": "mcarisnet.jpg"
	},
	{
		"source": "medialibre.eu",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "medialibreeu.jpg"
	},
	{
		"source": "mediamass.net",
		"language": "",
		"type": "satire",
		"notes": "",
		"fileName": "mediamassnet.jpg"
	},
	{
		"source": "medias-presse.info",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "mediaspresseinfo.jpg"
	},
	{
		"source": "mednat.org",
		"language": "",
		"type": "junksci",
		"notes": "",
		"fileName": "mednatorg.jpg"
	},
	{
		"source": "metatv.org",
		"language": "",
		"type": "fake",
		"notes": "",
		"fileName": "metatvorg.jpg"
	},
	{
		"source": "meteoweb.eu",
		"language": "",
		"type": "junksci",
		"notes": "",
		"fileName": "meteowebeu.jpg"
	},
	{
		"source": "michelcollon.info",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "michelcolloninfo.jpg"
	},
	{
		"source": "necenzurovane.net",
		"language": "",
		"type": "",
		"notes": "",
		"fileName": "necenzurovanenet.jpg"
	},
	{
		"source": "neovitruvian.wordpress.com",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "neovitruvianwordpresscom.jpg"
	},
	{
		"source": "news24roma.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "news24romacom.jpg"
	},
	{
		"source": "nocensura.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "nocensuracom.jpg"
	},
	{
		"source": "noinvasione.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "noinvasionecom.jpg"
	},
	{
		"source": "nonsiamosoli.com",
		"language": "",
		"type": "junksci",
		"notes": "",
		"fileName": "nonsiamosolicom.jpg"
	},
	{
		"source": "notixonline.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "notixonlinecom.jpg"
	},
	{
		"source": "notixweb.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "notixwebcom.jpg"
	},
	{
		"source": "notiziariosegreto.wordpress.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "notiziariosegretowordpresscom.jpg"
	},
	{
		"source": "notizie.delmondo.info",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "notiziedelmondoinfo.jpg"
	},
	{
		"source": "notiziedalpopolo.altervista.org",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "notiziedalpopoloaltervistaorg.jpg"
	},
	{
		"source": "notizieregionali.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "notizieregionalicom.jpg"
	},
	{
		"source": "notiziespericolate.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "notiziespericolatecom.jpg"
	},
	{
		"source": "nouvelordremondial.cc",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "nouvelordremondialcc.jpg"
	},
	{
		"source": "nwonuovoordinemondiale.wordpress.com",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "nwonuovoordinemondialewordpresscom.jpg"
	},
	{
		"source": "nwoo.org",
		"language": "",
		"type": "",
		"notes": "",
		"fileName": "nwooorg.jpg"
	},
	{
		"source": "onlinespravy.eu",
		"language": "",
		"type": "",
		"notes": "",
		"fileName": "onlinespravyeu.jpg"
	},
	{
		"source": "oumma.com",
		"language": "",
		"type": "fake, conspiracy",
		"notes": "",
		"fileName": "oummacom.jpg"
	},
	{
		"source": "panamza.com",
		"language": "",
		"type": "",
		"notes": "",
		"fileName": "panamzacom.jpg"
	},
	{
		"source": "pandapazzo.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "pandapazzocom.jpg"
	},
	{
		"source": "paradisefruit.altervista.org",
		"language": "",
		"type": "junksci",
		"notes": "",
		"fileName": "paradisefruitaltervistaorg.jpg"
	},
	{
		"source": "perdavvero.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "perdavverocom.jpg"
	},
	{
		"source": "pianetax.wordpress.com",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "pianetaxwordpresscom.jpg"
	},
	{
		"source": "piovegovernoladro.info",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "piovegovernoladroinfo.jpg"
	},
	{
		"source": "pluxactu.com",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "pluxactucom.jpg"
	},
	{
		"source": "politicanews.altervista.org",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "politicanewsaltervistaorg.jpg"
	},
	{
		"source": "pravdive.eu",
		"language": "",
		"type": "",
		"notes": "",
		"fileName": "pravdiveeu.jpg"
	},
	{
		"source": "presadicoscienza.altervista.org",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "presadicoscienzaaltervistaorg.jpg"
	},
	{
		"source": "proevropu.com",
		"language": "",
		"type": "",
		"notes": "",
		"fileName": "proevropucom.jpg"
	},
	{
		"source": "protiprudu.org",
		"language": "",
		"type": "",
		"notes": "",
		"fileName": "protipruduorg.jpg"
	},
	{
		"source": "prvopodstata.com",
		"language": "",
		"type": "",
		"notes": "",
		"fileName": "prvopodstatacom.jpg"
	},
	{
		"source": "quenelplus.com",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "quenelpluscom.jpg"
	},
	{
		"source": "realfunny.net",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "realfunnynet.jpg"
	},
	{
		"source": "realscience.altervista.org",
		"language": "",
		"type": "junksci",
		"notes": "",
		"fileName": "realsciencealtervistaorg.jpg"
	},
	{
		"source": "reopen911.info",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "reopen911info.jpg"
	},
	{
		"source": "repubblica24.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "repubblica24com.jpg"
	},
	{
		"source": "resistanceauthentique.wordpress.com",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "resistanceauthentiquewordpresscom.jpg"
	},
	{
		"source": "ribelli.eu",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "ribellieu.jpg"
	},
	{
		"source": "robadapazzi.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "robadapazzicom.jpg"
	},
	{
		"source": "rollingstone.altervista.org",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "rollingstonealtervistaorg.jpg"
	},
	{
		"source": "rougenoir76.over-blog.com",
		"language": "",
		"type": "",
		"notes": "",
		"fileName": "rougenoir76overblogcom.jpg"
	},
	{
		"source": "rustyjames.canalblog.com",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "rustyjamescanalblogcom.jpg"
	},
	{
		"source": "saltoquantico.org",
		"language": "",
		"type": "junksci",
		"notes": "",
		"fileName": "saltoquanticoorg.jpg"
	},
	{
		"source": "sante-nutrition.org",
		"language": "",
		"type": "",
		"notes": "",
		"fileName": "santenutritionorg.jpg"
	},
	{
		"source": "santenatureinnovation.com",
		"language": "",
		"type": "fake",
		"notes": "",
		"fileName": "santenatureinnovationcom.jpg"
	},
	{
		"source": "sapereeundovere.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "sapereeundoverecom.jpg"
	},
	{
		"source": "secretele.com",
		"language": "",
		"type": "",
		"notes": "",
		"fileName": "secretelecom.jpg"
	},
	{
		"source": "segretodistato.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "segretodistatocom.jpg"
	},
	{
		"source": "siamonapoletani.org",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "siamonapoletaniorg.jpg"
	},
	{
		"source": "socialnotixweb.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "socialnotixwebcom.jpg"
	},
	{
		"source": "sostenitori.info",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "sostenitoriinfo.jpg"
	},
	{
		"source": "stopeuro.org",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "stopeuroorg.jpg"
	},
	{
		"source": "stopislam.eu",
		"language": "",
		"type": "",
		"notes": "",
		"fileName": "stopislameu.jpg"
	},
	{
		"source": "stopmensonges.com",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "stopmensongescom.jpg"
	},
	{
		"source": "succedenelmondo.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "succedenelmondocom.jpg"
	},
	{
		"source": "sulatestagiannilannes.blogspot.com",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "sulatestagiannilannesblogspotcom.jpg"
	},
	{
		"source": "supernotizie.net",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "supernotizienet.jpg"
	},
	{
		"source": "svetkolemnas.info",
		"language": "",
		"type": "",
		"notes": "",
		"fileName": "svetkolemnasinfo.jpg"
	},
	{
		"source": "svobodnenoviny.eu",
		"language": "",
		"type": "",
		"notes": "",
		"fileName": "svobodnenovinyeu.jpg"
	},
	{
		"source": "tankerenemy.com",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "tankerenemycom.jpg"
	},
	{
		"source": "terrarealtime.blogspot.com",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "terrarealtimeblogspotcom.jpg"
	},
	{
		"source": "terrarealtime2.blogspot.com",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "terrarealtime2blogspotcom.jpg"
	},
	{
		"source": "tg24h.altervista.org",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "tg24haltervistaorg.jpg"
	},
	{
		"source": "theage.com.au",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "theagecomau.jpg"
	},
	{
		"source": "thetonicexpress.com",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "thetonicexpresscom.jpg"
	},
	{
		"source": "tmcrew.org",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "tmcreworg.jpg"
	},
	{
		"source": "toutsaufsarkozy.com",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "toutsaufsarkozycom.jpg"
	},
	{
		"source": "tuttiicriminidegliimmigrati.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "tuttiicriminidegliimmigraticom.jpg"
	},
	{
		"source": "tvlibertes.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "tvlibertescom.jpg"
	},
	{
		"source": "ultimenotizieflash.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "ultimenotizieflashcom.jpg"
	},
	{
		"source": "veritanwo.altervista.org",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "veritanwoaltervistaorg.jpg"
	},
	{
		"source": "videoscoop.info",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "videoscoopinfo.jpg"
	},
	{
		"source": "videoviraliweb.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "videoviraliwebcom.jpg"
	},
	{
		"source": "vivoinsalute.com",
		"language": "",
		"type": "junksci",
		"notes": "",
		"fileName": "vivoinsalutecom.jpg"
	},
	{
		"source": "voltairenet.org",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "voltairenetorg.jpg"
	},
	{
		"source": "voxnews.info",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "voxnewsinfo.jpg"
	},
	{
		"source": "voxnr.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "voxnrcom.jpg"
	},
	{
		"source": "web-news24.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "webnews24com.jpg"
	},
	{
		"source": "webnotice.altervista.org",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "webnoticealtervistaorg.jpg"
	},
	{
		"source": "wikistrike.com",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "wikistrikecom.jpg"
	},
	{
		"source": "wowchevideo.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "wowchevideocom.jpg"
	},
	{
		"source": "younetspiegalevele.altervista.org",
		"language": "",
		"type": "conspiracy",
		"notes": "",
		"fileName": "younetspiegalevelealtervistaorg.jpg"
	},
	{
		"source": "younetspiegalevele.info",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "younetspiegaleveleinfo.jpg"
	},
	{
		"source": "zonagrigianews.com",
		"language": "",
		"type": "bias",
		"notes": "",
		"fileName": "zonagrigianewscom.jpg"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/sources.json
// module id = 147
// module chunks = 0